import { AxiosResponse } from 'axios';
import environment from '@environment';
import { CacheAreaKey } from 'core/config/cache-config';
import { AccountDetailsDTO } from 'core/models/account/account-details.dto';
import { Account, AccountsDetailsDTO } from 'core/models/account/amount-to-pay.dto';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';
import { StorageHelper } from 'core/services/storage';
import { SiteConfigStore } from 'core/stores/site-config.store';

export class AccountMahService {
  private static apiBuilder = new EndpointHelper(`${environment.MAH_API_BASE_URL}/${environment.MAH_API_AMOUNT_TO_PAY}/${environment.MAH_API_VERSION}`);
  private static accountApiBuilder = new EndpointHelper(`${environment.MAH_API_BASE_URL}/${environment.MAH_API_ACCOUNT}/${environment.MAH_API_VERSION}`);
  private static psoApiBuilder = new EndpointHelper(`${environment.UNI_API_URI}/${environment.MAH_API_PAYMENT_PROCESSOR}/api/pso/v1/`);

  static getAmountToPay(customerNumber: string, country: string): Promise<AccountsDetailsDTO> {
    const url = this.apiBuilder.createUrl('AmountToPay')
      .addQueryParam('country', country)
      .addQueryParam('customerNumber', customerNumber)
      .addQueryParam('BusinessUnit', SiteConfigStore.businessUnit())
      .addQueryParam('Channel', SiteConfigStore.channel())
      .build();

    const storedItems = (StorageHelper<{ [key: string]: Account[] }[]>).GetInstance.getFromCache('req', url, CacheAreaKey.Account);
    if (storedItems) {
      return Promise.resolve(storedItems as AccountsDetailsDTO);
    }

    return HttpClient.GetInstance.get<AccountsDetailsDTO>(url)
      .then(
        (res: AxiosResponse<AccountsDetailsDTO>) => (
          (StorageHelper<AccountsDetailsDTO>).GetInstance.setCacheAndReturn('req', CacheAreaKey.Account, res?.data, url) as AccountsDetailsDTO
        )
      );
  }
  // https://qa-api.dstvafrica.com/paymentprocessor-unifiedpso/api/pso/v1/Payment/Limit/South Africa
  static getPaymentLimit(customerNumber: string, countryName: string): Promise<AccountsDetailsDTO> {
    const url = this.psoApiBuilder.createUrl('Payment')
      .addRouteParam('Limit')
      .addRouteParam(countryName)
      .addQueryParam('customerNumber', customerNumber)
      .addQueryParam('BusinessUnit', SiteConfigStore.businessUnit())
      .addQueryParam('Channel', SiteConfigStore.channel())
      .build();

    const storedItems = (StorageHelper<{ [key: string]: Account[] }[]>).GetInstance.getFromCache('req', url, CacheAreaKey.Account);
    if (storedItems) {
      return Promise.resolve(storedItems as AccountsDetailsDTO);
    }

    return HttpClient.GetInstance.get<AccountsDetailsDTO>(url)
      .then(
        (res: AxiosResponse<AccountsDetailsDTO>) => (
          (StorageHelper<AccountsDetailsDTO>).GetInstance.setCacheAndReturn('req', CacheAreaKey.Account, res?.data, url) as AccountsDetailsDTO
        )
      );
  }

  static getAccountDetails(customerNumber: string, country: string, accountNumber: number): Promise<AccountDetailsDTO> {
    const url = this.accountApiBuilder.createUrl('AccountService')
      .addRouteParam('GetAccountDetails')
      .addQueryParam('country', country)
      .addQueryParam('customerNumber', customerNumber)
      .addQueryParam('accountNumber', accountNumber)
      .addQueryParam('BusinessUnit', SiteConfigStore.businessUnit())
      .addQueryParam('Channel', SiteConfigStore.channel())
      .build();

    const storedItems = (StorageHelper<{ [key: string]: Account[] }[]>).GetInstance.getFromCache('req', url, CacheAreaKey.Account);
    if (storedItems) {
      return Promise.resolve(storedItems as AccountDetailsDTO);
    }

    return HttpClient.GetInstance.get<AccountDetailsDTO>(url)
      .then(
        (res: AxiosResponse<AccountDetailsDTO>) => (
          (StorageHelper<AccountDetailsDTO>).GetInstance.setCacheAndReturn('req', CacheAreaKey.Account, res?.data, url) as AccountDetailsDTO
        )
      );
  }

}